import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {formatDateToTime} from 'helpers/dateFormat';
import {getFirstLettersFromUsername} from 'helpers/getFirstLettersFromUsername';
import {Text, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface MessageProps {
  name: string;
  isMyMessage: boolean;
  time: number | Date | undefined;
  message: string;
}

const Message = (props: MessageProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme, props.isMyMessage);

  const UserView = (
    <View style={styles.userView}>
      <Text style={styles.name}>{getFirstLettersFromUsername(props.name)}</Text>
    </View>
  );

  const TopContent = (
    <View style={styles.topContentContainer}>
      <View style={styles.nameTimeContent}>
        <Text style={styles.username}>
          {props.isMyMessage ? strings.chat.you : props.name}
        </Text>
        <Text style={styles.time}>
          {props.time ? formatDateToTime(props.time) : ''}
        </Text>
      </View>
    </View>
  );

  const ContentView = (
    <View style={styles.contentContainer}>
      {TopContent}
      <View style={styles.messageContainer}>
        <Text style={styles.message}>{props.message}</Text>
      </View>
    </View>
  );

  return (
    <View style={styles.container}>
      {UserView}
      {ContentView}
    </View>
  );
};

export default Message;
